import customFormReducer from './customFormReducer';

export default customFormReducer;
